// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3527":"96c80bdd","4271":"d913559e","6946":"cdf7eada","8688":"29efc0fa"}[chunkId] + ".chunk.css";
};